import {Injectable} from '@angular/core';
import {SharedService} from '../shared/shared.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../app.reducer';
import {EmailAction} from './email.actions';
import * as selectors from './email.selectors';
import { IPayload } from 'src/app/services/payload/payload.interface';


@Injectable()
export class EmailService extends SharedService {

  public constructor(protected store: Store<AppState>, protected action: EmailAction) {
    super(store, action, selectors);
  }

  public sendEmail(emails: any, options = {}) {
    const data: IPayload = { data: { emails, options } };
    this.store.dispatch(this.action.sendEmail([data]));
  }

}
